module.exports = __webpack_public_path__ + "assets/docs/New Item Supplier Instructions.c08e75c5.pdf";